export const CONTEXT_ENUM = {
    SUBCATEGORY: 'CONTEXT_SUBCATEGORY',
    SEARCH: 'CONTEXT_SEARCH',
    PRO_SKILL: 'CONTEXT_PRO_SKILL',
    UNSPECIFIED: 'CONTEXT_UNSPECIFIED',
};
